import { Box } from '@mui/material'
import { ReactNode } from 'react'

interface TabPanelProps {
  children?: ReactNode
  index: number
  value: number
}

export function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props
  const hidden = value !== index
  const tabPanelId = `tabpanel-${index}`

  return (
    <Box role='tabpanel' hidden={hidden} id={tabPanelId}>
      {value === index && children}
    </Box>
  )
}
